module.exports = __webpack_public_path__ + "static/img/us.95cabb26.svg";